module.exports = __webpack_public_path__ + "img/technology_icon_10.af330f16.png";